import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    pageWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '40px',
        position: 'absolute',
        width: '100vw',
        height: 'auto',
        padding: '24px',
    },
    pageContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '560px'
    },
    title: {
        fontSize: '20px',
        lineHeight: '28px',
        margin: '32px 0 16px',
    },
    loaderWrapper: {
        width: '100%',
        display: 'flex',
        gap: '40px',
        flexDirection: 'column',
        alignItems: 'center',
    },
    modalWindow: {
        padding: '24px',
        margin: '0 32px'
    },
    '@media screen and (min-width: 390px) and (max-height: 844px)': {
        pageWrapper: {
            position: 'relative'
        }
    },
    '@media screen and (max-width: 375px)': {
        pageWrapper: {
            position: 'relative'
        }
    },
    '@media screen and (min-width: 768px)': {
        pageWrapper: {
            height: '100%',
        }
    }
});
